import { LocalStorageKey } from 'shared/constants/localStorage'
import { dispatchStorageEvent } from 'shared/utils/customEvents'
import { lsRemoveItem, lsSetItem } from 'shared/utils/local-storage'

interface AgentBridge {
  open?: () => void
  openWith?: (options: {
    prompt?: string
    context?: Record<string, unknown>
    autoSubmit?: boolean
    mode?: 'agents' | 'code'
  }) => void
  injectContext?: (context: Record<string, unknown>) => void
}

interface OpenChatOptions {
  mode?: 'agents' | 'code'
  context?: Record<string, unknown>
}

const AGENT_BRIDGE_READY_EVENT = 'clusterix-agent:ready'

const unhideLauncher = (): void => {
  lsRemoveItem(LocalStorageKey.AGENT_CHAT_WIDGET_HIDE_EXPIRY)
  lsSetItem(LocalStorageKey.AGENT_CHAT_WIDGET_VISIBLE, true)
  // native 'storage' event only fires cross-tab — dispatch a synthetic one so the
  // same-tab useLocalStorage subscribers (MainLayout, DesktopGridWrapper) re-render
  dispatchStorageEvent(LocalStorageKey.AGENT_CHAT_WIDGET_VISIBLE, 'true')
}

export const openAgentChat = (
  prompt?: string,
  options: OpenChatOptions = {}
): void => {
  unhideLauncher()

  const { mode, context } = options

  const invoke = (): boolean => {
    const bridge = (window as { clusterixAgent?: AgentBridge }).clusterixAgent
    if (!bridge) return false
    if (bridge.openWith) {
      bridge.openWith({ prompt, context, autoSubmit: false, mode })
    } else {
      bridge.open?.()
      if (context) bridge.injectContext?.(context)
    }
    return true
  }

  // bridge installs during the federation entry's first evaluation — if the
  // launcher was hidden, that chunk hasn't loaded yet, so wait for the chatbox
  // to fire its ready signal instead of polling on a timer
  if (!invoke()) {
    document.addEventListener(AGENT_BRIDGE_READY_EVENT, invoke, { once: true })
  }
}
